import { render } from "./navModal.vue?vue&type=template&id=654df72e"
import script from "./navModal.vue?vue&type=script&lang=js"
export * from "./navModal.vue?vue&type=script&lang=js"

import "./navModal.vue?vue&type=style&index=0&id=654df72e&lang=css"

import exportComponent from "/Users/Tomi/Documents/Projects/vue-wallet-connect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__